import { isValidDate } from "@shared";
import { startOfDay } from "date-fns";
import { TFunction } from "i18next";
import * as Yup from "yup";

import { ExchangeHistoryFilterValues } from "./ExchangeHistoryPanel.types";

export const ExchangeHistoryColumnWidth = {
  timestamp: 140,
  counselorUserCode: 140,
  appointment: 190,
  purposeKey: 190,
};

/** Both dates may be cleared to open that side of the window; mirrors GetAppointmentExchangeHistoryQueryValidator. */
export function exchangeHistoryFilterValidationSchema(t: TFunction): Yup.ObjectSchema<ExchangeHistoryFilterValues> {
  return Yup.object({
    fromDate: Yup.date().nullable().typeError(t("common.validation.invalidDateFormat")) as Yup.Schema<Date | null>,
    tillDate: Yup.date()
      .nullable()
      .typeError(t("common.validation.invalidDateFormat"))
      .test("till-not-before-from", t("exchange.history.validation.tillBeforeFrom"), function (tillDate) {
        const { fromDate } = this.parent as Pick<ExchangeHistoryFilterValues, "fromDate">;
        return !tillDate || !isValidDate(fromDate) || startOfDay(tillDate) >= startOfDay(fromDate);
      }) as Yup.Schema<Date | null>,
    givenAwayByCounselorId: Yup.string().nullable() as Yup.Schema<string | null>,
    exchangedWithCounselorId: Yup.string().nullable() as Yup.Schema<string | null>,
  });
}
